/**
 * Rich text editors emit non-empty markup (e.g. "") for an empty
 * field. Normalize such visually-empty HTML to null before sending to the API.
 */
export default function emptyHtmlToNull(value: string | null | undefined): string | null {
  if (!value) {
    return null;
  }

  const stripped = value.replace(/<[^>]*>/g, "").replace(/&nbsp;/g, " ").trim();

  return stripped ? value : null;
}
